module.exports = __webpack_public_path__ + "media/images/pic/umbrella-a25640d652b2bd3772c1dd91a9c8528e.jpg";